var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7715 0.773438H4.77148C2.56235 0.773438 0.771484 2.5643 0.771484 4.77344V10.7734C0.771484 12.9826 2.56235 14.7734 4.77148 14.7734H10.7715C12.9806 14.7734 14.7715 12.9826 14.7715 10.7734V4.77344C14.7715 2.5643 12.9806 0.773438 10.7715 0.773438Z",
    stroke: "#4C6484",
    strokeWidth: 1.54302
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77148 7.19135V10.7734M4.77148 4.77344V4.78239M7.77148 7.19135V7.72866M7.77148 7.72866V10.7734M7.77148 7.72866C9.77148 7.2809 10.7715 7.15642 10.7715 8.17642V10.7734",
    stroke: "#4C6484",
    strokeWidth: 1.54302,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.03aa928724ba10e452fa9ecb98f2abf1.svg";
export { ForwardRef as ReactComponent };